import AuthService from 'cio/services/auth';
import { getOwner } from '@ember/application';
import AnalyticsService, { EventProperties } from 'cio/services/analytics';
import { EventType } from 'cio/utils/analytics/events';

export class DemoAnalyticsAuthService extends AuthService {
  user = null as any;
}

declare module '@ember/service' {
  interface Registry {
    'demo-analytics-auth': DemoAnalyticsAuthService;
  }
}

const DEMO_EVENT_PREFIX = 'Demo: ';

function prefixEventNameString(name: string | undefined) {
  if (name == null) {
    return name;
  }

  return `${DEMO_EVENT_PREFIX}${name}`;
}

// Override analytics service to only send anon tracking calls, and prefix their
// names to make them easy to filter out
export default class DemoAnalyticsService extends AnalyticsService {
  auth!: DemoAnalyticsAuthService; // not yet registered so cannot use "@service" decorator for injection

  constructor() {
    super(...arguments);

    // need to register and inject manually in Ember 4.4:
    getOwner(this).register('service:demo-analytics-auth', DemoAnalyticsAuthService);
    this.auth = getOwner(this).lookup('service:demo-analytics-auth');
  }

  async trackEventFunc(event: EventType, data: EventProperties = {}) {
    let eventClone = { ...event };

    eventClone.name = (data: EventProperties = {}) => {
      if (typeof event.name !== 'function') {
        return prefixEventNameString(event.name);
      }
      let name = event.name(data);
      return prefixEventNameString(name);
    };

    return super.trackEventFunc(eventClone, data);
  }
}
